import { LinkType } from '@ria-client/segment/enums';
import type { AnalyticsType } from '@ria-client/segment/types';
import { EntityPlacementCtaTypeEnum } from '@ria-client/supergraph/marketplace/enums';
import type { CtaType } from '@ria-client/supergraph/roundup/types';
import { CtaButton, RiaDisclaimer, TrackedLink } from '@ria-client/tw-shared-ui';
import Image from 'next/image';

export interface BankInstitutionCellProps {
  image?: {
    source?: string;
    alt?: string;
  };
  cta: CtaType | null;
  displayName?: string;
  analyticsPayload: AnalyticsType;
  isFidelityOffer?: boolean;
  isRiaOffer?: boolean;
  riaDisclaimerText?: string;
}

export function BankInstitutionCell({
  image,
  cta,
  displayName,
  analyticsPayload,
  isFidelityOffer = false,
  isRiaOffer = false,
  riaDisclaimerText,
}: BankInstitutionCellProps) {
  const logo = image?.source ? (
    <Image
      alt={image.alt ?? displayName ?? 'Bank Logo'}
      className="max-h-11 max-w-[122px] object-contain md:max-h-[60px] md:max-w-[171px]"
      height={60}
      src={image.source}
      width={171}
    />
  ) : null;

  return (
    <div className="w-[175px] md:w-auto">
      {cta ? (
        <TrackedLink
          analyticsPayload={analyticsPayload}
          cta={{ ...cta, type: EntityPlacementCtaTypeEnum.ProductImage }}
          className="flex"
          linkType={LinkType.PRODUCT_IMAGE}
          monetizable={analyticsPayload.monetizable}
        >
          {logo}
        </TrackedLink>
      ) : (
        logo
      )}
      <p className="typography-text-small mt-1">{displayName}</p>
      <div className="mt-2 block max-w-[189px] md:hidden">
        {cta ? (
          <CtaButton
            analyticsPayload={analyticsPayload}
            className="h-[29px] md:h-[45px]"
            cta={cta}
          />
        ) : null}
        {isRiaOffer && riaDisclaimerText ? (
          <div className="mt-2">
            <RiaDisclaimer
              isFidelityOffer={isFidelityOffer}
              monetizable={analyticsPayload.monetizable}
              riaDisclaimerText={riaDisclaimerText}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}
